export default {
  versionTabItem: 'cursor-pointer min-w-fit px-[16px] py-[8px] rounded-full transition ease-out duration-300 hover:bg-[#F0F3F6]',
  versionTabItemActive: 'bg-[#0A52A1] text-color-white hover:bg-[#0A52A1]',
};
